import flow from 'lodash/fp/flow';
import identity from 'lodash/fp/identity';
import isUndefined from 'lodash/fp/isUndefined';
import pull from 'lodash/fp/pull';
import set from 'lodash/fp/set';
import {
  DELETE_ACTIVITY,
  DISABLE_ACTIVITY_FILTER,
  ENABLE_ACTIVITY_FILTER,
  FILTER_ACTIVITIES,
  LIST_ACTIVITIES,
  LIST_ACTIVITIES_SUCCESS,
  SUPERSEDE_ACTIVITY,
  TOGGLE_STAFF_ACTIVITIES,
} from '../constants/activity';

const defaultMapState = {
  projects: {},
  enabledFilters: [],
  isStaffActivityListVisible: false,
};

const activityReducer = (state = defaultMapState, action) => {
  switch (action.type) {
    case LIST_ACTIVITIES: {
      return flow([
        set(['projects', action.payload.projectId, 'ui', 'isLoading'], true),
      ])(state);
    }
    case TOGGLE_STAFF_ACTIVITIES: {
      return flow([
        set('isStaffActivityListVisible', !state.isStaffActivityListVisible),
      ])(state);
    }
    case LIST_ACTIVITIES_SUCCESS: {
      const { projectId, activities } = action.payload;
      return flow([
        set(['projects', projectId, 'ui', 'isLoading'], false),
        set(['projects', projectId, 'activities'], activities),
        set(['projects', projectId, 'nonFilteredActivities'], activities),
      ])(state);
    }
    case FILTER_ACTIVITIES: {
      const { projectId, activities } = action.payload;
      return flow([
        set(['projects', projectId, 'activities'], activities),
        isUndefined(state.projects[projectId]?.nonFilteredActivities)
          ? set(['projects', projectId, 'nonFilteredActivities'], activities)
          : identity,
      ])(state);
    }
    case ENABLE_ACTIVITY_FILTER: {
      const { filterName } = action.payload;
      return flow([
        set(['enabledFilters'], state.enabledFilters.concat(filterName)),
      ])(state);
    }
    case DISABLE_ACTIVITY_FILTER: {
      const { filterName } = action.payload;
      return flow([
        set(['enabledFilters'], pull(filterName, state.enabledFilters)),
      ])(state);
    }
    case DELETE_ACTIVITY: {
      const { projectId, activityId } = action.payload;
      const { activities = [], nonFilteredActivities = [] } =
        state.projects?.[projectId] || {};

      const updatedActivities = activities.reduce((acc, activity) => {
        if (activity.id === activityId) {
          // Skip this activity as it's being superseded
          return acc;
        }
        acc.push(activity);
        return acc;
      }, []);
      const filteredNonFilteredActivities = nonFilteredActivities.filter(
        (activity) => activity.id !== activityId
      );

      return flow([
        set(['projects', projectId, 'activities'], updatedActivities),
        set(
          ['projects', projectId, 'nonFilteredActivities'],
          filteredNonFilteredActivities
        ),
      ])(state);
    }
    case SUPERSEDE_ACTIVITY: {
      const { projectId, activityId, supersededAssets } = action.payload;
      const { activities = [], nonFilteredActivities = [] } =
        state.projects?.[projectId] || {};

      const updatedActivities = activities.reduce((acc, activity) => {
        if (activity.id === activityId) {
          acc.push({ ...activity, superseded_assets: supersededAssets });
        } else {
          acc.push(activity);
        }
        return acc;
      }, []);

      const updatedNonFilteredActivities = nonFilteredActivities.reduce(
        (acc, activity) => {
          if (activity.id === activityId) {
            acc.push({ ...activity, superseded_assets: supersededAssets });
          } else {
            acc.push(activity);
          }
          return acc;
        },
        []
      );

      return flow([
        set(['projects', projectId, 'activities'], updatedActivities),
        set(
          ['projects', projectId, 'nonFilteredActivities'],
          updatedNonFilteredActivities
        ),
      ])(state);
    }

    default:
      return state;
  }
};

export default activityReducer;
